export default __webpack_public_path__ + "media/images/icons/new-youtube-e4c0e94eefeb29e65b56bbe75f32e0f0.svg";